<template>
  <CModal
    :title="title"
    :color="color"
    size="lg"
    :show.sync="showModal"
  >
    <template>
      <AssignRulesPlantilla ref="assignRulesPlantilla"/>
    </template>
    <br>
    <br>

    <CForm id="objectives_form" method="POST" enctype="multipart/form-data">
      <CRow>
        <CCol md="12">
          <a style="float: right; font-size: 12px;" target="_blank" href="https://api.kpibonus.com/objectives.xlsx">Descargar Plantilla</a>
          <CInput
            label="Archivo a Importar:"
            name="objectives_file"
            id="objectives_file"
            type="file"
            :lazy="false"
            :value.sync="$v.form_import.objectives_file.$model"
            placeholder=""
            autocomplete="given-name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
            required
          />
        </CCol>
      </CRow>
    </CForm>
    <CRow>
      <CCol md="12">
        <details style="margin-top: 1rem; font-size: 13px;">
          <summary><strong>Ver instrucciones para importar Objetivos</strong></summary>
          <div style="margin-top: 1rem; font-size: 13px;">
            <strong>Instrucciones para importar:</strong>
            <ul style="padding-left: 1.2rem; margin-top: 0.5rem;">
              <li>Descarga la plantilla predeterminada <strong>(Incluye los campos requeridos, primera hoja del Excel)</strong>.</li>
              <li>Los campos marcados con asterisco (<strong>*</strong>) son obligatorios.</li>
              <li>Las columnas deben tener estos nombres exactos (respetar mayúsculas):</li>
            </ul>
            <table style="font-size: 12px; width: 100%;">
              <thead>
                <tr>
                  <th style="text-align: left;">Columna</th>
                  <th style="text-align: left;">Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>TIPO</td><td>*Tipo de objetivo (ej: Venta por Monto, Cajas Cantidad).</td></tr>
                <tr><td>NOMBRE</td><td>*Nombre del objetivo.</td></tr>
                <tr><td>DESCRIPCION</td><td>Descripción opcional del objetivo.</td></tr>
                <tr><td>ENFOQUE</td><td>*Unico o Repetitivo.</td></tr>
                <tr><td>OBJETIVO_CONCURSO</td><td>*Cantidad que se necesita alcanzar para empezar a premiar.</td></tr>
                <tr><td>MIN_CANT_PARTICIPAR</td><td>*Cantidad mínima para poder participar.</td></tr>
                <tr><td>MAX_CANT_PARTIPAR</td><td>*Cantidad máxima que se toma en cuenta (topado).</td></tr>
                <tr><td>CANT_INI_PREMIO</td><td>Cantidad desde donde se empieza a calcular premio (inicio).</td></tr>
                <tr><td>PREMIO</td><td>*Tipo de premio (ej: Puntos Digitales, Monedero Electrónico).</td></tr>
                <tr><td>CANT_PREMIO</td><td>*Cantidad de premio por cumplimiento.</td></tr>
                <tr><td>RUTA</td><td>Código del vendedor. Se crea si no existe.</td></tr>
                <tr><td>NOMBRE_VEND</td><td>Nombre del vendedor (opcional si ya existe).</td></tr>
                <tr><td>CODIGO_CLIENTE</td><td>Código del cliente. Se crea si no existe.</td></tr>
                <tr><td>NOMBRE_CLIENTE</td><td>Nombre del cliente (opcional si ya existe).</td></tr>
              </tbody>
            </table>
          </div>
        </details>
      </CCol>
    </CRow>
    <template v-if="hasErrorsImport == 1">
      <CRow>
        <CCol md="12">
          <CAlert color="danger" variant="solid">
            <strong>Se encontraron los siguientes errores al importar:</strong>
          </CAlert>
            <CDataTable
              :items="importIssues"
              :fields="['N°', 'Fila', 'Columna', 'Error']"
              :items-per-page="10"
              hover
              bordered
              small
              responsive
              class="mt-3"
              :no-sorting="true"
              :sorter="false"
            >
              <template #N°="{ index }">
                <td style="font-size: 10px;">
                  {{ index + 1 }}
                </td>                
              </template>
              <template #Fila="{ item }">
                <td style="font-size: 10px;">
                  {{ item.row || '-' }}
                </td>
                
              </template>
              <template #Columna="{ item }">
                <td style="font-size: 10px;">
                  {{ item.column || '-' }}
                </td>                
              </template>
              <template #Error="{ item }">
                <td style="font-size: 10px;">
                  {{ item.message }}
                </td>                
              </template>
            </CDataTable>
        </CCol>
      </CRow>
    </template>
    <template v-else-if="hasErrorsImport == 0 && submitted">
      <CRow>
        <CCol md="12">
          <CAlert color="success" variant="solid">
            <strong>¡El archivo se importó correctamente sin errores!</strong>
          </CAlert>
        </CCol>
      </CRow>
    </template>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="importAvailables" :color="color">Importar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required  } from "vuelidate/lib/validators"
import ws from '../../../services/challenges';
import store from '../../../store'
import AssignRulesPlantilla from "./AssignRulesPlantilla.vue";

export default {
  name: 'ImportObjectivesModal',
  components: { AssignRulesPlantilla },
  data () {
    return {
      showModal: false,
      title: "Importar Objetivos",
      color: "success",
      isEdit: false,
      form_import: this.getEmptyForm(),
      submitted: false,
      importIssues: [],
      hasErrorsImport: 0,
    }
  },
  mounted: async function() {    
  },
  methods: {
    async importAvailables () {
      this.loading();
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        const form = document.getElementById("objectives_form");
        let formData = new FormData(form);

        formData.append("challenge_id", this.form_import.challenge_id);

        let response = await ws.importObjectives(formData);

        if(response.type == "success"){
          this.hasErrorsImport = response.data.has_errors_objectives ? 1 : 0;
          this.importIssues = response.data.objectives_errors;
          this.$emit("refresh");
        }

        this.loaded();
      }
      else{
        this.loaded();
        this.showToast("error", "Debes ingresar un archivo XLSX para poder continuar.");
      }
    },
    closeModal () {
      this.showModal = false;

      this.form_import = this.getEmptyForm()
      this.submitted = false
      this.hasErrorsImport = 0;
      this.importIssues = [];
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          challenge_id: 0,
          objectives_file: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form_import[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    async openModal () {
      await this.$refs.assignRulesPlantilla.loadData();
      this.showModal = true;
      this.color = "success";
      this.title = 'Importar Objetivos';
      this.isEdit = false;
      this.submitted = false;
      this.hasErrorsImport = 0;
      this.importIssues = [];

      this.form_import = {
          challenge_id: this.$route.params.challenge_id,
          objectives_file: ''
      };      
      this.showModal = true;    
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form_import, null, 4) },
    isValid () { return !this.$v.form_import.$invalid },
    isDirty () { return this.$v.form_import.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form_import: {
      objectives_file: {
        required
      }
    }
  },
}
</script>